import React, { createContext, useContext } from 'react';

interface ModalComponentsContextType {
  PdfModalComponent?: React.ComponentType<any>;
  VideoModalComponent?: React.ComponentType<any>;
}

const ModalComponentsContext = createContext<ModalComponentsContextType>({
  PdfModalComponent: undefined,
  VideoModalComponent: undefined,
});

export const useModalComponents = () => useContext(ModalComponentsContext);

// Legacy hook for backward compatibility
export const usePdfModal = () =>
{
  const context = useModalComponents();
  return { PdfModalComponent: context.PdfModalComponent };
};

interface ModalComponentsProviderProps {
  children: React.ReactNode;
  PdfModalComponent?: React.ComponentType<any>;
  VideoModalComponent?: React.ComponentType<any>;
}

export const ModalComponentsProvider: React.FC<ModalComponentsProviderProps> = ({
  children,
  PdfModalComponent,
  VideoModalComponent,
}) =>
{
  return (
    <ModalComponentsContext.Provider value={{ PdfModalComponent, VideoModalComponent }}>
      {children}
    </ModalComponentsContext.Provider>
  );
};

// Legacy export for backward compatibility
export const PdfModalProvider = ModalComponentsProvider;
